export const PlatformPeople = 'PlatformPeople';
export const SearchPlatformPeople = PlatformPeople + '/Search';
export const DeletePlatformPerson = PlatformPeople + "/Person";
export const PlatformPeopleEmploymentData = 'PlatformPeopleEmploymentData/';
export const ValidateIdNumber = PlatformPeople + "/ValidateIdNumber";
export const ValidateEmployeeCode = PlatformPeople + "/ValidateEmployeeCode";
